define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/xml"
], function(declare, Action, xml) {

	return declare(Action, {
		// Boolean: indicates if action can apply to image ref attribute
		bAllowImageRef: false,

		constructor: function(obj) {
			this.m_right = xml.RIGHT_WRITE;
		},

		getImageValue: function(/*Node*/node) {
			// summary: access current value for Images
			return node?.[this.idAttr];
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable all image actions if not showing gallery
			return ctx.view.displaysPropertyImage() && this.inherited(arguments);
		},

		validate: function(/*Context*/ctx) {
			// summary: action not allowed if printing or if not Image tag specified
			return !ctx.bPrint && !!ctx.defView.getImage();
		}
	});
});